import styled from 'styled-components';

export const Btn = styled.button`
  display: inline-block;
  padding: 10px 20px;
  text-align: center;
  width: ${(props) => (props.width ? props.width : '250px')};
  font-weight: 600;
  margin-left: ${({ marginLeft }) => marginLeft || '5px'};
  margin-right: ${({ marginRight }) => marginRight || '5px'};
  cursor: pointer;
  background-color: ${(props) => props.color || '#FB8501'};
  border: none;
  border-radius: 5px;
  align-self: ${(props) => props.alignSelf};
  z-index: 1;
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.textColor || '#fff'};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
`;

export const MainContainer = styled.div`
  padding: ${({ paddingVertical }) => paddingVertical || '0px'} 100px;
  padding-right: ${({ paddingRight }) => paddingRight};
  padding-left: ${({ paddingLeft }) => paddingLeft};
  background-color: ${(props) => props.bgColor};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'column'};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItem};
  position: ${({ position }) => position};
  transition: all 1s;
  @media (max-width: 1024px) {
    padding: ${({ paddingVertical }) => paddingVertical || '0px'} 70px;
  }
  @media (max-width: 960px) {
    padding: ${({ paddingVertical }) => paddingVertical || '0px'} 50px;
  }
  @media (max-width: 768px) {
    padding: ${({ paddingVertical }) => paddingVertical || '0px'} 20px;
  }
`;

export const Heading = styled.h2`
  color: #023047;
  font-size: 2.5em;
  align-self: center;
  font-weight: bold;
  margin-bottom: ${({ marginBottom }) => marginBottom || '1em'};
  margin-top: ${({ marginTop }) => marginTop};
  text-align: center;
  text-transform: uppercase;
  @media (max-width: 1080px) {
    font-size: 2.3em;
  }
  @media (max-width: 768px) {
    font-size: 2em;
  }
  @media (max-width: 425px) {
    font-size: 1.5em;
  }
`;

export const BoxShadow = styled.div`
  box-shadow: 20px 14px 32px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
`;

export const CommonBtn = styled.button`
  color: white;
  background-color: #fb8501;
  border: none;
  padding: 0.5em 2em;
  border-radius: 10px;
  font-weight: 700;
  align-self: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: fit-content;
  margin: ${({ margin }) => margin};
  text-transform: uppercase;
`;

export const HalfColoredContainer = styled.div`
  background-color: #f6f8fb;
  position: relative;
  overflow: hidden;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 1.5em;
  &::after {
    content: '';
    background-color: ${({ color }) => color};
    position: absolute;
    left: -50%;
    right: -50%;
    top: 50%;
    height: 100%;
    transform: rotate(345deg);
  }
  &::before {
    content: '';
    position: absolute;
    background-image: url('../../assets/dotpattern.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    right: -2.5%;
    top: 10%;
    width: 150px;
    height: 150px;
    z-index: 1;
  }
`;
